import React, { useCallback, useEffect,useState } from "react";
import Swal from "sweetalert2";
import { organizationService } from "../lib/api/organization";
import { serverUrl, serverImgUrl } from '../config/constants';
import { Table, Button, Spinner, Form as RBForm } from "react-bootstrap";
import { routes } from "../routes/routes-names";
import { useNavigate } from "react-router-dom";
import PdfViewer from "./PdfViewer";
type Organization= {
  id: number;
  organizationName: string;
  registrationNumber:string;
  address:string;
  city:string;
  state:string;
  country:string;
  bankAccountNumber:string;
  bankBranchNumber:string;
  bankIfscCode:string;
  email: string;
  contactNumber: string;
  paymentStatus: string;
  organizationType: string;
  registartionCertificate: string;
  coveringLetter:string;
  declarationSheet:string;
}

const OrganiztionApprovalPage: React.FC = () => {
  const navigate = useNavigate();
  
  const [expandedRow, setExpandedRow] = useState<number | null>(null);
  const [organizations, setOrganizations] = useState<Organization[]>([]);
  const [disablebtn, setDisablebtn] = useState(false);
  const [remarks, setRemarks] = useState('');
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(15);

  const toggleRow = (id: number) => {
    setExpandedRow(expandedRow === id ? null : id);
  };

   const submit = useCallback(async (status: any,id:any) => {
        if (status) {
            setDisablebtn(true);
            const orgApprovalInfo = {
                approval_status: status,
                remarks: remarks
            }
            const { success } = await organizationService.updateOrgApprovals(id, orgApprovalInfo);
            if (success) {
                let msg="Organization Details Updated Successfully";
                    Swal.fire({
                        title: "",
                        text: msg,
                        icon: status === 'rej' ?"error":"success",
                        confirmButtonText: "OK",
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            setDisablebtn(false);
                        }
                    });
                    navigate(routes.adminLayout);
                }
                else {
                    Swal.fire({
                        title: "",
                        text: "org registration rejected",
                        icon: "error",
                        confirmButtonText: "OK",
                    }).then(async (result) => {
                    });
                }
        }
        else {
            Swal.fire({
                //title: "Error",
                text: "something went wrong",
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    }, [remarks]);

  const getOrganizationDetails = useCallback(async (status:string) => {
        try {
              setOrganizations([]);
                const { data } = await organizationService.getOrganizationDetailsforVerification(status);
                if (data.length > 0) {
                  setOrganizations(data);
                }
            
        } catch (err) {
            console.log('error getOrganizationDetails', err);
        }
        finally {
          setLoading(false);
        }
    }, [organizations]);
    
   useEffect(() => {
        getOrganizationDetails('pen');
    }, []);

    const totalPages = Math.ceil(organizations.length / recordsPerPage);
    
      const paginatedData = () => {
        const start = (currentPage - 1) * recordsPerPage;
        return organizations.slice(start, start + recordsPerPage);
      };
    
      const handlePageChange = (page: number) => {
        if (page >= 1 && page <= totalPages) {
          setCurrentPage(page);
        }
      };
    
    
    
  if (loading) {
    return (
      <div className="d-flex justify-content-center mt-5">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <div className="container  mt-4">
      <h3 className="mb-3 text-center cme-header">Organization Approvals</h3>
      
                <div className="d-flex  justify-content-end align-items-center mb-3 gap-2 flex-wrap" style={{paddingRight:"700px"}}>
                  <Button variant="info"
                   onClick={()=>getOrganizationDetails('pen')}>
                   Pending
                  </Button>
                  <Button variant="secondary"
                   onClick={()=>getOrganizationDetails('ver')}>
                   Verified
                  </Button>
                  <Button variant="primary" onClick={()=>getOrganizationDetails('apr')}>
                    Approved
                  </Button>
                   <Button variant="warning" onClick={()=>getOrganizationDetails('rej')}>
                                                                    Rejected
                                                                  </Button>
                </div>
      <Table bordered hover responsive>
        <thead className="table-primary">
          <tr>
            <th style={{ width: "50px" }}></th>
            <th>Organization Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {organizations.map((org) => (
            <React.Fragment key={org.id}>
              <tr>
                <td
                  onClick={() => toggleRow(org.id)}
                  style={{ cursor: "pointer", textAlign: "center" }}
                >
                  {expandedRow === org.id ? (
                    <i className="bi bi-chevron-up"></i>
                  ) : (
                    <i className="bi bi-chevron-down"></i>
                  )}
                </td>
                <td>{org.organizationName}</td>
                <td>{org.email}</td>
                <td>{org.contactNumber}</td>
                <td>
                  <span
                    className={`badge ${
                      org.paymentStatus === "Pending"
                        ? "bg-warning text-dark"
                        : "bg-success"
                    }`}
                  >
                    {org.paymentStatus ==='pen' &&"Pending"}
                    {org.paymentStatus ==='rej' &&"Rejected"}
                    {org.paymentStatus ==='ver' &&"Verified"}
                    {org.paymentStatus ==='apr' &&"Approved"}
                  </span>
                </td>
              </tr>

              {expandedRow === org.id && (
                <><tr>
                  <td></td>
                  <td>
                    <strong>Organization Type:</strong>
                    <p>{org.organizationType}</p>
                  </td>
                    <td> 
                    <strong>Registration Number:</strong>
                    <p>{org.registrationNumber}</p>
                    </td>
                    <td colSpan={2}> 
                    <strong>address</strong>
                    <p>{org.address+","+org.city+","+org.state+""+org.country}</p>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td>
                    <strong>Bank Account Number</strong>
                    <p>{org.bankAccountNumber}</p>
                  </td>
                  <td>
                    <strong>Bank Branch Number</strong>
                    <p>{org.bankBranchNumber}</p>
                  </td>
                  <td colSpan={2}>
                    <strong>Bank IFSC Code</strong>
                    <p>{org.bankIfscCode}</p>
                  </td>
                </tr>
                <tr>
                    <td colSpan={2}>
                      <strong>Registration Certificate:</strong>
                      <div className="d-flex flex-wrap gap-2 mt-2">
                        {org.registartionCertificate &&
                          <div className="col">
                            <div className="drag-img-box d-flex align-items-center justify-content-center">
                              {<PdfViewer fileUrl ={serverImgUrl + '/org/' + org.registartionCertificate} />}
                            </div>
                          </div>}
                      </div>

                    </td>
                    <td colSpan={2}>
                          <strong>Covering Letter:</strong>
                      <div className="d-flex flex-wrap gap-2 mt-2">
                        {org.coveringLetter &&
                          <div className="col">
                            <div className="drag-img-box d-flex align-items-center justify-content-center">
                                {<PdfViewer fileUrl ={serverImgUrl + '/org/' + org.coveringLetter} />}
                            </div>
                          </div>}
                      </div>
                    </td>
                    <td colSpan={2}>
                          <strong>Declaration Sheet:</strong>
                      <div className="d-flex flex-wrap gap-2 mt-2">
                        {org.declarationSheet &&
                          <div className="col">
                            <div className="drag-img-box d-flex align-items-center justify-content-center">
                                {<PdfViewer fileUrl ={serverImgUrl + '/org/' + org.declarationSheet} />}
                            </div>
                          </div>}
                      </div>

                    </td>
                    </tr>
                    <tr>
                      {org.paymentStatus==='pen'&&
                    <td colSpan={6}>
                       <div className="card-footer">
                            <div className="mb-3">
                                <label htmlFor="" className='mb-2'>Reason <span className='fs-12'>{'(Enter reason if you are rejecting application)'}</span></label>
                                <textarea className='form-control fs-14' onChange={(e) => setRemarks(e.target.value)} name="" id="" placeholder='Enter Reason'></textarea>
                            </div>
                            <div className='d-flex'>
                                <div className="col">
                                    <button type="submit" 
                                    disabled={disablebtn}
                                    onClick={() => {
                                        submit('rej',org.id);
                                    }} className='btn btn-danger'><i className="bi-x-circle"></i> Not Accepted</button>
                                </div>
                                <div className="col text-end">
                                    <button type="submit"
                                    disabled={disablebtn}
                                        onClick={() => {
                                            submit('ver',org.id);
                                        }} className='btn btn-success'><i className="bi-check-circle"></i> Verified</button>
                                </div>
                            </div>
                        </div>
                    </td>
                      }

                  </tr></>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </Table>
      <div className="d-flex align-items-center flex-wrap gap-3 mb-2 w-100 mt-2">
        <div className="d-flex align-items-center gap-2">
          <RBForm.Label className="mb-0 fw-semibold">Rows per page</RBForm.Label>
          <RBForm.Select
            size="sm"
            value={recordsPerPage}
            onChange={(e) => {
              setRecordsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
            style={{ width: "auto" }}
          >
            {[10, 15, 25, 50, 100].map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </RBForm.Select>
        </div>

        {totalPages > 1 && (
          <div className="d-flex justify-content-center align-items-center gap-2 ms-auto">
            <Button
              size="sm"
              variant="outline-secondary"
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
            >
              « First
            </Button>
            <Button
              size="sm"
              variant="outline-secondary"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              ‹ Prev
            </Button>
            <RBForm.Select
              size="sm"
              value={currentPage}
              onChange={(e) => handlePageChange(Number(e.target.value))}
              style={{ width: "auto" }}
            >
              {[...Array(totalPages)].map((_, i) => (
                <option key={i} value={i + 1}>
                  Page {i + 1} of {totalPages}
                </option>
              ))}
            </RBForm.Select>
            <Button
              size="sm"
              variant="outline-secondary"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next ›
            </Button>
            <Button
              size="sm"
              variant="outline-secondary"
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
            >
              Last »
            </Button>
          </div>
        )}
      </div>

    
    </div>
  );
};

export default OrganiztionApprovalPage;
